export default "__VITE_ASSET__cBm40gse__"